import { createContext } from "react";

export const CreatePage = createContext({
  createPage: "",
  handleCreatePage: () => {},
});
